<template>
	<div>
		<Letter>
			<template #pre-header>
				<slot name="pre-header"> </slot>
			</template>

		    <div class="text-sm md:text-md">
		        <div class="space-y-3">
		          <div class="flex gap-2">
		            <span class="font-medium underline text-offset-2">Effective Date:</span>
		            <span>{{ new Date().toDateString() }}</span>
		          </div>
		          <div class="flex gap-2">
		            <span class="font-medium underline text-offset-2">Borrower's Name:</span>
		            <span>{{ guarantor.customer_name }}</span>
		          </div>
		          <div class="flex gap-2">
		            <span class="font-medium underline text-offset-2">Borrower's Address:</span>
		            <span>{{ guarantor.customer_address }}</span>
		          </div>
		        </div>
		
		        <div class="mt-5">
		          This Guarantee is given on the <b class="underline"><span>{{ date.day }}</span> day of  {{ date.month }} {{ date.year }}</b> by Mr/Mrs/Miss <b class="underline">{{ guarantor.name }}</b> of <b class="underline">{{ guarantor.address }}</b> (hereinafter called the ‘<b class="underline">Guarantor</b>’ to the <b class="underline">‘Lender’ SYCAMORE.NG</b> a Company incorporated under the laws of the Federal Republic of Nigeria with an office situated at 52b Oduduwa Way, GRA Ikeja, Lagos, Nigeria (hereinafter referred to as the ‘Lender’ which the expression shall wherever the context so admit include its heirs, executors, administrators and assigns) about the Borrower’s payment obligations under the subsisting loan agreement between SYCAMORE.NG and the Borrower.
		        </div>
		
		        <div class="mt-5">
		          <span class="font-semibold text-md mb">The Guarantor covenants thus:</span>
		          <div>
		            To unconditionally and irrevocably agree based on a personal guarantee
		            to grant <b class="underline">{{ guarantor.customer_name }}</b> of <b
		              class="underline">{{ guarantor.customer_address }}</b> (Hereinafter referred to as the
		            ‘Borrower’ which the expressions shall wherever the context so admits
		            include his heirs, executors, administrators and assigns) a loan
		            Finance facility of the sum of <b class="underline">({{ guarantor.currency?.symbol }}{{ guarantor.loan_amount.toLocaleString() }})</b>
		            under the following conditions:
		          </div>
		          <ol class="list-decimal list-inside space-y-5 mt-3 ml-2">
		            <li>
		              Where the Borrower fails to make good on any of his outstanding debt obligations following repeated attempts by SYCAMORE.NG to collect the same, SYCAMORE.NG shall have recourse to me to settle the outstanding debt (principal and accrued interest) promptly.
		            </li>
		            <li>
		              Notwithstanding, that this Agreement may be amended from time to time by the parties without notice to me, I understand that such amendment and failure to be notified of the same, shall not release me from my liability under this Guarantee.
		            </li>
		            <li>
		              In consideration of the Lender executing the Loan Agreement, the Guarantor guarantees to the Lender, whenever the Borrower does not pay any of the Guaranteed Obligations when due, to immediately pay such Guaranteed Obligations upon demand by the Lender.
		            </li>
		            <li>
		              The Guarantor shall promptly on demand, pay to, or reimburse, the Lender on a full indemnity basis, all costs, charges, expenses, Taxes and liabilities of any kind (including, without limitation, legal, printing and out-of-pocket expenses) incurred by the Lender in connection with:
		              <ol class="ml-3 space-y-4 mt-2 list-decimal list-inside">
		                <li> the preparation, negotiation, execution and delivery of this Guarantee;</li>
		                <li>any actual or proposed amendment, variation, supplement, waiver or consent under or in connection with this Guarantee;</li>
		                <li>any discharge or release of this Guarantee;</li>
		                <li> the preservation, or exercise and enforcement, of any rights under or in connection with this Guarantee or any attempt so to do; and</li>
		                <li> any stamping or registration of this Guarantee.</li>
		              </ol>
		            </li>
		            <li>
		              The Lender shall be entitled to set off the Guarantor’s liability under this Guarantee against any or all fixed and floating assets, listed in the notarized personal net-worth form herewith attached, in the name of the Guarantor (whether sole or joint with any other persons) in any location with the Lender, its subsidiaries or affiliates.
		            </li>
		            <li>
		              <span class="font-semibold">Payments</span>
		              <ol class="mt-2 list-inside list-decimal ml-3 space-y-4">
		                <li>
		                  All sums payable by the Guarantor under this Guarantee shall be paid in full to the Lender in the currency in which the Guaranteed Obligations are payable:
		                  <ol class="mt-2 list-inside list-decimal ml-3 space-y-4">
		                    <li>
		                      without any set-off, condition or counterclaim whatsoever; and
		                    </li>
		                    <li>
		                      free and clear of any deduction or withholding whatsoever except as may be required by law or regulation which is binding on the Guarantor.
		                    </li>
		                  </ol>
		                </li>
		                <li>
		                  If the Guarantor is required to make any deduction or withholding by any law or regulation from any payment due under this Guarantee, the payment due from the Guarantor shall be increased to an amount which (after making any deduction or withholding) leaves an amount equal to the payment which would have been due if no deduction or withholding had been required.
		                </li>
		                <li>
		                  Following any deduction or withholding, or any payment required in connection with that deduction or withholding, the Guarantor shall promptly deliver or procure delivery to the Lender evidence reasonably satisfactory to the Lender that either a withholding or deduction has been made or any appropriate payment paid to the relevant taxing authority (as applicable).
		                </li>
		                <li>
		                  The Guarantor shall not and may not direct the application by the Lender of any sums received by the Lender from the Guarantor under, or according to, any of the terms of this Guarantee.
		                </li>
		              </ol>
		            </li>
		            <li>
		              <span class="font-semibold">Collateral</span>
		              <div>
		                Where there is a collateral as a guarantee for the loan, the collateral shall be administered with the terms and conditions of this guarantee/agreement. All the terms above shall be fully enforceable and applied to the collateral.
		              </div>
		            </li>
		          </ol>
		        </div>
		
		        <div class="mt-8 space-y-3">
		          <h3 class="font-semibold mb-2"> Guarantor Information </h3>
		          <div class="flex gap-2">
		            <span class="font-medium underline text-offset-2">Mr/Mrs/Miss</span>
		            <span>{{ guarantor.name }}</span>
		          </div>
		          <div class="flex gap-2">
		            <span class="font-medium underline text-offset-2">Guarantor Address:</span>
		            <span>{{ guarantor.address }}</span>
		          </div>
		          <div v-if="guarantor.bvn" class="flex gap-2">
		            <span class="font-medium underline text-offset-2">BVN:</span>
		            <span>{{ guarantor.bvn }}</span>
		          </div>
		          <div class="flex gap-2">
		            <span class="font-medium underline text-offset-2">Occupation:</span>
		            <span>{{ guarantor.occupation }}</span>
		          </div>
		          <div class="flex gap-2">
		            <span class="font-medium underline text-offset-2">Business Address:</span>
		            <span>{{ guarantor.business_address }}</span>
		          </div>
		          <div class="flex flex-col md:flex-row items-start justify-between gap-5 w-full">
		            <div class="flex gap-2">
		              <span class="font-medium underline text-offset-2">Phone Number:</span>
		              <span>{{ guarantor.phone }}</span>
		            </div>
		            
		              <div class="max-md:mx-auto is-4-tablet is-offset-4-tablet is-5-mobile is-offset-2-mobile flex flex-col">
		                <a v-if="guarantor.signature" :href="renderImage(guarantor.signature ?? '')" target="_blank">
		                    <img :src="renderImage(guarantor.signature)" alt="Signature." class="h-20 w-full object-contain">
		                </a>
		              </div>
		          </div>
		        </div>
		
		        <div v-if="next" class="column is-12">
		          <div class="buttons flex justify-end items-end mt-5">
		            <b-button
		                ref="submitReviewForm"
		                native-type="submit"
		                @click="next"
		                :disabled="loading"
		                :loading="loading"
		                class="button is-primary text-sm md:w-48 mx-auto"
		            >
		              {{ next_text }}
		            </b-button>
		          </div>
		        </div>
		    </div>
		</Letter>
	</div>
</template>

<script>
import Letter from "@/components/letter";

export default {
	components: { Letter },
        data() {
            return {
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            }
        },
        props: {
	       	guarantor: Object,
	        next: Function,
			next_text: String,
			loading: Boolean,
        },
        computed: {
        	date() {
				const date = new Date();
	        	return {
			        month: this.months[date.getMonth()],
					day: date.getDate(),
					year: date.getFullYear(),
		        }
         	}
        },
        methods: {
			scrollToBottom() {
			    this.$refs.submitReviewForm.$el.scrollIntoView({
					behavior: "smooth",
					block: "end",
					inline: "nearest"
				});
			},
			renderImage(file) {
				if (!file) return;
				return URL.createObjectURL(file)
			}
        },
    }
</script>
